module.exports = __webpack_public_path__ + "static/media/logo_1.547c4079.png";